import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { IoCheckmarkCircleSharp } from "react-icons/io5";
import img1 from '../images/about1.webp'
import img2 from '../images/about2.webp'
import img3 from '../images/about_bg.webp'
import { useMediaQuery } from 'react-responsive';

const About = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div className={`about-section  position-relative ${isMobile ? 'py-30' : 'py-50'}`} id='plans'>
        <Container className='position-relative'>
            <Row>
                <Col lg={7} md={12} sm={12} xs={12}>
                    <h2 className='mb-3 text-capitalize'>Spacious 3 BHK Apartments Tailored for Modern Living</h2>
                    <ul>
                        <li><span><IoCheckmarkCircleSharp /></span><p>Sizes: 1655 sq. ft. – 2455 sq. ft.</p></li>
                        <li><span><IoCheckmarkCircleSharp /></span><p>3 BHK Configuration: Perfect for families <br/>Or those seeking extra space</p></li>
                        <li><span><IoCheckmarkCircleSharp /></span><p>Vitrified tile flooring in living rooms and <br/>bedrooms</p></li>
                        <li><span><IoCheckmarkCircleSharp /></span><p>Granite countertops and modern fixtures <br/>In the kitchen</p></li>
                        <li><span><IoCheckmarkCircleSharp /></span><p>Large balconies offering serene views</p></li>
                    </ul>
                </Col>
                <Col lg={5} md={12} sm={12} xs={12}>
                        {isMobile ? 
                        <Row className='mt-4'>
                            <Col md={6}><img src={img2} alt="dinning" className='img-fluid'></img></Col>
                            <Col md={6}><img src={img1} alt="bedroom" className='img-fluid'></img></Col>
                        </Row>
                    :
                    <>
                    <img src={img2} alt="dinning" className='img-fluid mb-20'></img>
                    <img src={img1} alt="bedroom" className='img-fluid'></img>
                    </>
                    }
                    
                   
                </Col>
            </Row>
        </Container>
        <img src={img3} alt="background" className='img-fluid background-img position-absolute bottom-0'></img>
    </div>
  )
}

export default About
